import { useCallback, useState } from 'react';

export function useAutoExecuteState() {  
  const [autoExecute, setAutoExecute] = useState(true);
  const toggleAutoExecution = useCallback(() => {    
    setAutoExecute(!autoExecute);
  }, [autoExecute]);

  return {
    autoExecute,
    toggleAutoExecution
  };
}
